import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { AxiosError } from 'axios';
import { XeroReportTaxType } from '../types/entity';

type GetXeroReportTaxTypesResponse = {
    xeroReportTaxTypes: XeroReportTaxType[];
};

async function getXeroReportTaxTypes(): Promise<GetXeroReportTaxTypesResponse> {
    const { data } = await api.get(`/xero-report-tax-types`);
    return data;
}

export function useXeroReportTaxTypes(): UseQueryResult<GetXeroReportTaxTypesResponse, AxiosError> {
    return useQuery(['xero-report-tax-types'], () => getXeroReportTaxTypes(), {
        keepPreviousData: true,
    });
}
